var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResultFrontend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.387 159.548C180.387 164.288 176.56 168.115 171.82 168.115H28.1367C23.3965 168.115 19.5696 164.288 19.5696 159.548V64.2663C19.5696 59.5261 23.3965 55.6992 28.1367 55.6992H171.82C176.56 55.6992 180.387 59.5261 180.387 64.2663V159.548Z",
    fill: "#1E0F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 158.896V160.984C0 165.506 4.78365 169.203 10.6545 169.203H189.346C195.216 169.203 200 165.506 200 160.984V158.896H0Z",
    fill: "#D3D3D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8752 62.8748V150.111H173.342V70.1372H25.8752V62.8748Z",
    fill: "#E6EEF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.081 78.0952H130.202V131.324H170.081V78.0952Z",
    fill: "#EEEEEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173.342 62.8748H25.8752V70.1372H173.342V62.8748Z",
    fill: "#FFD049"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.419 62.8748H34.7903V145.588H125.419V62.8748Z",
    fill: "#EEEEEF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.476 172.203C189.432 172.203 189.432 172.203 189.476 172.203C189.432 172.203 189.432 172.203 189.476 172.203ZM189.519 172.203C189.476 172.203 189.476 172.203 189.519 172.203C189.476 172.203 189.476 172.203 189.519 172.203ZM194.39 170.942C192.912 171.725 191.259 172.203 189.519 172.203C191.259 172.203 192.955 171.725 194.39 170.942ZM194.434 170.898C194.434 170.942 194.434 170.942 194.434 170.898C194.434 170.942 194.434 170.942 194.434 170.898ZM194.477 170.898C194.477 170.898 194.434 170.898 194.434 170.942C194.434 170.898 194.477 170.898 194.477 170.898ZM194.521 170.855C194.521 170.898 194.477 170.898 194.521 170.855C194.477 170.898 194.521 170.898 194.521 170.855ZM194.564 170.855C194.521 170.855 194.521 170.855 194.564 170.855C194.521 170.855 194.521 170.855 194.564 170.855ZM194.608 170.811C194.564 170.811 194.564 170.855 194.608 170.811C194.564 170.855 194.564 170.811 194.608 170.811Z",
    fill: "#535671"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.956 164.462H1.00037C2.69639 167.245 6.34936 169.159 10.5677 169.159H10.6112H189.302H189.346C189.346 169.159 189.346 169.159 189.389 169.159H189.433C189.433 169.159 189.433 169.159 189.476 169.159C191.259 169.115 192.912 168.767 194.347 168.159C194.347 168.159 194.347 168.159 194.39 168.159H194.434C194.434 168.159 194.434 168.159 194.477 168.159C194.477 168.159 194.477 168.159 194.521 168.159C196.521 167.245 198 165.984 198.956 164.462Z",
    fill: "#66646D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168.036 76.5737H127.941V129.15H168.036V76.5737Z",
    fill: "#5B5433"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.987 82.0529H131.941V82.6617H141.987V82.0529Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M137.247 83.5751H131.941V84.1839H137.247V83.5751Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M140.508 85.1401H131.941V85.749H140.508V85.1401Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M140.9 88.2285H135.898V88.8373H140.9V88.2285Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M144.247 89.7938H139.378V90.4025H144.247V89.7938Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M148.032 83.5751H138.986V84.1839H148.032V83.5751Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M153.641 83.5751H149.336V84.1838H153.641V83.5751Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M161.122 83.5751H155.294V84.1839H161.122V83.5751Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M146.988 85.1401H141.9V85.749H146.988V85.1401Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.9 86.7058H139.943H135.898V87.3146H139.943H140.9H145.335V86.7058H140.9Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M147.423 88.2285H142.422V88.8373H147.423V88.2285Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M152.294 86.7058H146.727V87.3146H152.294V86.7058Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M156.294 86.7058H153.381V87.3145H156.294V86.7058Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M161.121 86.7058H157.512V87.3145H161.121V86.7058Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M154.816 88.2285H148.51V88.8373H154.816V88.2285Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M157.642 88.2285H155.773V88.8372H157.642V88.2285Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M149.205 89.7938H145.597V90.4025H149.205V89.7938Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M140.9 92.925H135.898V93.5339H140.9V92.925Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M140.9 94.4467H135.898V95.0555H140.9V94.4467Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M146.9 94.4467H142.422V95.0553H146.9V94.4467Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.423 92.925H146.727H142.422V93.5339H146.727H147.423H150.989V92.925H147.423Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M154.076 92.925H151.815V93.5337H154.076V92.925Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M157.816 92.925H155.033V93.5337H157.816V92.925Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M156.295 94.4467H151.293V95.0555H156.295V94.4467Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M140.9 96.0125H135.898V96.6213H140.9V96.0125Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M140.9 97.5775H135.898V98.1863H140.9V97.5775Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M145.335 96.0125H142.422V96.6211H145.335V96.0125Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M151.554 97.5775H142.422V98.1863H151.554V97.5775Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.25 96.0125H149.989H146.727V96.6213H149.989H152.25H156.294V96.0125H152.25Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M161.121 96.0125H157.512V96.6211H161.121V96.0125Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M157.817 97.5775H152.685V98.1863H157.817V97.5775Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M150.032 94.4467H147.901V95.0553H150.032V94.4467Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M137.247 100.666H131.941V101.275H137.247V100.666Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M140.508 102.231H131.941V102.84H140.508V102.231Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M140.9 103.797H135.898V104.406H140.9V103.797Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M140.9 105.319H135.898V105.971H140.9V105.319Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.249 100.666H145.292H138.986V101.318H145.292H146.249H147.858V100.666H146.249Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M157.512 100.666H149.467V101.275H157.512V100.666Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M146.988 102.231H141.9V102.84H146.988V102.231Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M146.291 105.319H142.422V105.971H146.291V105.319Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.119 103.797H149.467H142.422V104.406H149.467H150.119H153.729V103.797H150.119Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M154.816 105.319H147.423V105.971H154.816V105.319Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M157.642 105.319H155.773V105.971H157.642V105.319Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M149.205 106.884H145.597V107.493H149.205V106.884Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.205 106.884H142.9H139.378V107.493H142.9H144.205H156.729V106.884H144.205Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M159.73 106.884H157.729V107.493H159.73V106.884Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M140.9 109.972H135.899V110.581H140.9V109.972Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M140.9 111.538H135.899V112.147H140.9V111.538Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M150.641 109.972H142.422V110.581H150.641V109.972Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M146.9 111.538H142.422V112.146H146.9V111.538Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M154.076 109.972H151.815V110.581H154.076V109.972Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M157.816 109.972H155.033V110.581H157.816V109.972Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M156.294 111.538H151.293V112.147H156.294V111.538Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M150.032 111.538H147.901V112.146H150.032V111.538Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M137.247 114.103H131.941V114.712H137.247V114.103Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M140.508 115.625H131.941V116.234H140.508V115.625Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M140.9 117.191H135.898V117.799H140.9V117.191Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M140.9 118.756H135.898V119.365H140.9V118.756Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M144.247 120.279H139.378V120.888H144.247V120.279Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M143.988 114.103H138.986V114.712H143.988V114.103Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.554 114.103H149.467H145.292V114.712H149.467H150.554H161.122V114.103H150.554Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M146.988 115.625H141.9V116.234H146.988V115.625Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M146.291 118.756H142.422V119.365H146.291V118.756Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.989 117.191H149.467H142.422V117.799H149.467H149.989H153.729V117.191H149.989Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M157.381 117.191H154.816V117.799H157.381V117.191Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M161.121 117.191H158.643V117.799H161.121V117.191Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M154.816 118.756H147.423V119.365H154.816V118.756Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M157.642 118.756H155.773V119.365H157.642V118.756Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M149.205 120.279H145.597V120.888H149.205V120.279Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M140.9 124.975H135.898V125.584H140.9V124.975Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.9 123.41H139.073H135.898V124.019H139.073H140.9H150.641V123.41H140.9Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M146.9 124.975H142.422V125.584H146.9V124.975Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M154.076 123.41H151.815V124.018H154.076V123.41Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M157.816 123.41H155.033V124.018H157.816V123.41Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M156.295 124.975H151.293V125.584H156.295V124.975Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M150.032 124.975H147.901V125.584H150.032V124.975Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M168.036 76.5737H127.941V79.7049H168.036V76.5737Z",
    fill: "#FFD049"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.079 77.9215C166.079 78.3563 165.731 78.7476 165.253 78.7476C164.818 78.7476 164.427 78.3998 164.427 77.9215C164.427 77.4868 164.775 77.0955 165.253 77.0955C165.731 77.0955 166.079 77.4868 166.079 77.9215Z",
    fill: "#E7E5E4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.383 77.9215C163.383 78.3563 163.035 78.7476 162.557 78.7476C162.122 78.7476 161.731 78.3998 161.731 77.9215C161.731 77.4868 162.079 77.0955 162.557 77.0955C162.992 77.0955 163.383 77.4868 163.383 77.9215Z",
    fill: "#E7E5E4"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M123.636 38H32.094V143.545H123.636V38Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M123.636 38H32.094V43.0881H123.636V38Z",
    fill: "#FFD049"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.069 40.3913C121.069 41.0435 120.504 41.6087 119.852 41.6087C119.2 41.6087 118.635 41.0435 118.635 40.3913C118.635 39.7392 119.2 39.174 119.852 39.174C120.548 39.174 121.069 39.7392 121.069 40.3913Z",
    fill: "#E7E5E4"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.025 40.3913C117.025 41.0435 116.46 41.6087 115.807 41.6087C115.112 41.6087 114.59 41.0435 114.59 40.3913C114.59 39.7392 115.155 39.174 115.807 39.174C116.46 39.174 117.025 39.7392 117.025 40.3913Z",
    fill: "#E7E5E4"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M123.636 52.2642H32.094V58.222H123.636V52.2642Z",
    fill: "#FFD049"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M118.504 53.9169H90.4543V56.5261H118.504V53.9169Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5319 54.3511H38.3127V56.0906H46.5319V54.3511Z",
    fill: "#E3E3E3"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4035 54.3511H47.1843V56.0906H55.4035V54.3511Z",
    fill: "#E3E3E3"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3183 54.3511H56.0991V56.0906H64.3183V54.3511Z",
    fill: "#E3E3E3"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1899 54.3511H64.9707V56.0906H73.1899V54.3511Z",
    fill: "#E3E3E3"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8842 67.05H50.2284V80.5747H66.8842V67.05Z",
    fill: "#79CFCD"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.331 54.2209C119.983 54.2209 119.678 54.5253 119.678 54.8731C119.678 55.2209 119.983 55.5253 120.331 55.5253C120.678 55.5253 120.983 55.2209 120.983 54.8731C120.983 54.5253 120.678 54.2209 120.331 54.2209ZM119.722 54.3079C120.07 53.96 120.635 53.96 120.939 54.3079C121.287 54.6557 121.287 55.1774 120.939 55.5253C120.591 55.8731 120.026 55.8731 119.722 55.5253C119.374 55.1774 119.374 54.6122 119.722 54.3079Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.113 55.8299L120.939 55.656C120.983 55.6125 121.026 55.6125 121.026 55.569C121.07 55.5256 121.113 55.4821 121.113 55.4386L121.331 55.6125L121.113 55.8299Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.113 56.3954C122.2 56.4823 122.2 56.5693 122.113 56.6563C122.026 56.7432 121.939 56.7432 121.852 56.6563L121.07 55.9171L121.331 55.6562L122.113 56.3954Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.287 55.4388C120.33 55.4388 120.417 55.4388 120.461 55.3953C120.504 55.3953 120.504 55.3518 120.504 55.3083C120.504 55.2649 120.461 55.2648 120.417 55.2648C120.374 55.2648 120.33 55.3083 120.287 55.3083C120.157 55.3083 120.07 55.2214 120.026 55.1344C120.026 55.0909 119.983 55.0909 119.939 55.0909C119.896 55.0909 119.896 55.1344 119.896 55.1779C119.939 55.3518 120.113 55.4388 120.287 55.4388Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4098 66.963H68.754V80.4877H85.4098V66.963Z",
    fill: "#FFD049"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M103.979 66.876H87.3235V80.4007H103.979V66.876Z",
    fill: "#E6EEF2"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2747 126.497H39.3999V127.671H63.2747V126.497Z",
    fill: "#D3D3D3"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2747 128.628H39.3999V129.802H63.2747V128.628Z",
    fill: "#D3D3D3"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2747 130.759H39.3999V131.933H63.2747V130.759Z",
    fill: "#D3D3D3"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2747 132.89H39.3999V134.064H63.2747V132.89Z",
    fill: "#D3D3D3"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2747 135.021H39.3999V136.196H63.2747V135.021Z",
    fill: "#D3D3D3"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2747 137.152H39.3999V138.326H63.2747V137.152Z",
    fill: "#D3D3D3"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2747 139.283H39.3999V140.457H63.2747V139.283Z",
    fill: "#D3D3D3"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1064 126.497H66.2317V127.671H90.1064V126.497Z",
    fill: "#D3D3D3"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1064 128.628H66.2317V129.802H90.1064V128.628Z",
    fill: "#D3D3D3"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1064 130.759H66.2317V131.933H90.1064V130.759Z",
    fill: "#D3D3D3"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1064 132.89H66.2317V134.064H90.1064V132.89Z",
    fill: "#D3D3D3"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1064 135.021H66.2317V136.196H90.1064V135.021Z",
    fill: "#D3D3D3"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1064 137.152H66.2317V138.326H90.1064V137.152Z",
    fill: "#D3D3D3"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1064 139.283H66.2317V140.457H90.1064V139.283Z",
    fill: "#D3D3D3"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M117.069 126.497H93.1941V127.671H117.069V126.497Z",
    fill: "#D3D3D3"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M117.069 128.628H93.1941V129.802H117.069V128.628Z",
    fill: "#D3D3D3"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M117.069 130.759H93.1941V131.933H117.069V130.759Z",
    fill: "#D3D3D3"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M117.069 132.89H93.1941V134.064H117.069V132.89Z",
    fill: "#D3D3D3"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M117.069 135.021H93.1941V136.196H117.069V135.021Z",
    fill: "#D3D3D3"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M117.069 137.152H93.1941V138.326H117.069V137.152Z",
    fill: "#D3D3D3"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M117.069 139.283H93.1941V140.457H117.069V139.283Z",
    fill: "#D3D3D3"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M123.636 89.3157H32.094V117.887H123.636V89.3157Z",
    fill: "#FFD049"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M64.275 94.0558H40.6611V113.19H64.275V94.0558Z",
    fill: "#E3E3E3"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M108.111 100.753H70.3632V101.362H108.111V100.753Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M108.111 102.318H70.3632V102.927H108.111V102.318Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M108.111 103.884H70.3632V104.493H108.111V103.884Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2381 105.406H70.3632V106.015H95.2381V105.406Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1377 103.623L34.2681 102.971L35.3986 102.319V103.623V104.928L34.2681 104.275L33.1377 103.623Z",
    fill: "#E3E3E3"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.591 103.623L121.461 102.971L120.331 102.319V103.623V104.928L121.461 104.275L122.591 103.623Z",
    fill: "#E3E3E3"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2747 119.235H39.3999V125.41H63.2747V119.235Z",
    fill: "#79CFCD"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1064 119.496H66.2317V125.671H90.1064V119.496Z",
    fill: "#E6EEF2"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M117.069 119.583H93.1941V125.758H117.069V119.583Z",
    fill: "#FFD049"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultFrontend);
export default __webpack_public_path__ + "static/media/result_frontend.24d5f249cafb96dbf7b0c27746b41b63.svg";
export { ForwardRef as ReactComponent };